import { useEffect } from 'react'
import { AuthRouteImport } from './Import'
const { useNavigate, Swal } = AuthRouteImport

export default function PageNotFound() {

    const navigate = useNavigate()

    useEffect(() => {
        Swal.fire({
            title: 'Oops...',
            text: '404 Page Not Found!',
            icon: 'error',
            confirmButtonColor: '#222124',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                navigate(-1)
            }
        })
    }, [])

    return (
        <></>
    )
}
